import ReactDOM from "react-dom";

// Portal Concept of React for Tooltip
const Tooltip = ({ productName, position }) => {
  return ReactDOM.createPortal(
    <div 
      className="rd-quote-tooltip-text rd-quote-text-xs"
      style={{ top: position.top, left: position.left, position: "fixed" }}
    >
      {productName}
    </div>,
    document.getElementById('tooltip-root')  // Make sure this exists in your HTML
  );
};

export default Tooltip;
